// Product Recommendation swiper
window.addEventListener("load", function() {
  // var elem = document.querySelector('.js-flickity-carousel');
  // var flkty = new Flickity( elem, {
  //   // options
  //   contain: true,
  //   imagesLoaded: true,
  //   lazyLoad: 1,
  //   pageDots: false,
  //   prevNextButtons: false,
  //   freeScroll: true

  // });
  var swiperProduct = new Swiper(".js-swiper-carousel", {
      slidesPerView: 1,
        spaceBetween: 10,
        observer: true,  
        observeParents: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
      });
});

// load-more-function
$('.js-load-more').on('click', function(){
  var $this = $(this),
        totalPages = parseInt($('[data-total-pages]').val()),
        currentPage = parseInt($('[data-current-page]').val()) + 1;
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+(currentPage));
    //console.log(nextUrl);
    $('[data-current-page]').val(currentPage);

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
    },
    complete: function() {
      if(currentPage < totalPages) {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        } else {
          $this.hide();
        }
    }
  })
});
  
